const { createContext } = require("react");

const AppointmentContext = createContext({});

export default AppointmentContext;
